/**
 * usePageTracking Hook
 * 
 * Automatically tracks page views in Google Analytics 
 * when routes change in React Router.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/core/services/analytics';

/**
 * Hook to track page views automatically on route changes
 * Use this in your App.tsx or layout component
 */
export function usePageTracking(): void {
    const location = useLocation();

    useEffect(() => {
        // Track page view on route change
        // Use hash for HashRouter (remove the leading #)
        const path = location.pathname;
        const title = document.title;

        trackPageView(path, title);
    }, [location.pathname]);
}
